import { BrowserRouter } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import { RecoilRoot } from 'recoil';
import RecoilNexus from 'recoil-nexus';

// routes
import Router from './routes/routes';
// theme
// import ThemeProvider from './theme';
// components
import ScrollToTop from './components/scroll-to-top';
import FacilityIdentifier from './components/facilityIdentifier';

import './App.css';
import './index.scss';
import { AuthProvider } from './contexts/auth-context';


export default function App() {
  return (
    <RecoilRoot>
      
      <RecoilNexus />
      <HelmetProvider>
        <BrowserRouter>
        <AuthProvider>
          {/* <ThemeProvider> */}
            <ScrollToTop /> 
            <FacilityIdentifier /> 
            <Router />
          {/* </ThemeProvider> */}
          </AuthProvider>
        </BrowserRouter>
      </HelmetProvider>
    </RecoilRoot>
  );
}